import { FlexCell, FlexRow } from '@epam/promo';
import css from './Skeleton.module.scss';

export const SkeletonPage = () => (
  <FlexRow cx={css.page__container}>
    <FlexCell cx={['skeleton-loader', css.list]} grow={1} />
    <FlexCell cx={['skeleton-loader', css.panel]} grow={2.5} />
    <FlexCell grow={1} />
  </FlexRow>
);
